import { useGetRenewVisaDocumentGroupInfo } from "@/api/services/main/renew-visa";
import { Button } from "@/components/elements/Button";
import { Modal } from "@/components/elements/Modal";
import { RefreshEmployeeInfoBtn } from "@/features/renew-visa/components/applicationStep/formApplication/employeeApplication/RefreshEmployeeInfoBtn";
import { useGetPreventEmployeeApplicationModalState } from "@/features/renew-visa/hook/useGetPreventEmployeeApplicationModalState";
import { TEmployeeApplicationForm } from "@/features/renew-visa/types/employeeApplicationForm";
import { useCacheLocal } from "@/hooks/useCacheLocal";
import { useVisible } from "@/hooks/useVisible";
import { AppRoutes } from "@/routes/config";
import { RENEW_VISA_DOCUMENT_STATUS } from "@/types/enum";
import { getDynamicRoute } from "@/utils/url";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Link } from "react-router-dom";

type TRemindPassportModalProps = {
  setIsEditable?: (v: boolean) => void;
};

export const RemindPassportModal: FC<TRemindPassportModalProps> = ({ setIsEditable }) => {
  const methods = useFormContext<TEmployeeApplicationForm>();

  const { control } = methods;

  const employeeInfoPassportCode = useWatch({ control, name: "employeeInfoPassportCode" });

  const employeeIdWatchField = useWatch({ control, name: "employeeId" });

  const { alwaysOpenPreventEmployeeApplicationModal } = useGetPreventEmployeeApplicationModalState();

  const modal = useVisible();

  const hiddenRenewVisaRemindPassportModalStorage = useCacheLocal("hidden-renew-visa-remind-passport-modal-storage");

  const hiddenStorageValue = hiddenRenewVisaRemindPassportModalStorage.getJSON();

  const { data: renewVisaDocumentGroup } = useGetRenewVisaDocumentGroupInfo();

  useEffect(() => {
    if (
      !!renewVisaDocumentGroup &&
      renewVisaDocumentGroup.status !== RENEW_VISA_DOCUMENT_STATUS.COMPLETE &&
      !alwaysOpenPreventEmployeeApplicationModal &&
      (hiddenStorageValue === null ||
        !Array.isArray(hiddenStorageValue) ||
        (Array.isArray(hiddenStorageValue) && !hiddenStorageValue.includes(employeeIdWatchField))) &&
      !employeeInfoPassportCode
    ) {
      modal.open();
    }
  }, [alwaysOpenPreventEmployeeApplicationModal, renewVisaDocumentGroup, employeeInfoPassportCode, employeeIdWatchField, hiddenStorageValue]);

  return (
    <Modal isOpen={modal.visible} width={480} enableFooter={false} enableCloseIcon={false}>
      <Typography component="p" pt={1} variant="body14">
        外国人の旅券番号が記入されていませんが、続行して良いですか？
      </Typography>
      <Stack mt={3} alignItems="center">
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            const existingData = hiddenRenewVisaRemindPassportModalStorage.getJSON() || [];
            if (!Array.isArray(existingData)) {
              hiddenRenewVisaRemindPassportModalStorage.setJSON([employeeIdWatchField]);
            }
            if (Array.isArray(existingData) && !existingData?.includes(employeeIdWatchField)) {
              hiddenRenewVisaRemindPassportModalStorage.setJSON([...existingData, employeeIdWatchField]);
            }
            modal.close();
          }}
        >
          OK
        </Button>
        <Stack flexDirection="row" justifyContent="center" alignItems="center" gap={2} mt={2}>
          <RefreshEmployeeInfoBtn
            setIsEditable={setIsEditable}
            handleCallback={() => {
              const existingData = hiddenRenewVisaRemindPassportModalStorage.getJSON() || [];
              if (!Array.isArray(existingData)) {
                hiddenRenewVisaRemindPassportModalStorage.setJSON([employeeIdWatchField]);
              }
              if (Array.isArray(existingData) && !existingData?.includes(employeeIdWatchField)) {
                hiddenRenewVisaRemindPassportModalStorage.setJSON([...existingData, employeeIdWatchField]);
              }
              modal.close();
            }}
          />
          <Button
            variant="primary"
            size="sm"
            component={Link}
            target="_blank"
            onClick={() => {
              const existingData = hiddenRenewVisaRemindPassportModalStorage.getJSON() || [];
              if (!Array.isArray(existingData)) {
                hiddenRenewVisaRemindPassportModalStorage.setJSON([employeeIdWatchField]);
              }
              if (Array.isArray(existingData) && !existingData?.includes(employeeIdWatchField)) {
                hiddenRenewVisaRemindPassportModalStorage.setJSON([...existingData, employeeIdWatchField]);
              }
            }}
            to={`${getDynamicRoute(AppRoutes.employeeEdit, { id: employeeIdWatchField })}#passport_code_input`}
          >
            特定技能外国人の編集へ
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
